
import 'core-js/fn/symbol';
import 'core-js/fn/promise';
import 'src/app/modernizr';

import setSpeedBumpClassLinks from '@/utils/speed-bump-links';
// import setSsoInterceptLinks from '@/utils/sso-intercept-links'; // removed by C.Castle
import selectAll from '@/utils/select-all';
import customEventPolyfill from '@/utils/custom-event';
import objectFitPolyfill from '@/utils/object-fit';
import focusWithinPolyfill from '@/utils/focus-within';

// import postscribe from 'postscribe';
import Vue from 'vue';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import VueScrollTo from 'vue-scrollto';

import '@/index.js';

import App from './app.vue';

import 'src/app/sass/style.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

// Demo-only components
import Component from './components/component.vue';

// UI Kit
import Buttons from './ui-kit/buttons.vue';
import ColorPalette from './ui-kit/color-palette.vue';
import Dropdown from './ui-kit/dropdown.vue';
import Facets from './ui-kit/facets.vue';
import InputsFeedback from './ui-kit/inputs-feedback.vue';
import Inputs from './ui-kit/inputs.vue';
import LargeInputsFeedback from './ui-kit/large-inputs-feedback.vue';
import LargeInputs from './ui-kit/large-inputs.vue';
import Pagination from './ui-kit/pagination.vue';
import RadioButtons from './ui-kit/radio-buttons.vue';
import Tabs from './ui-kit/tabs.vue';
import Tags from './ui-kit/tags.vue';
import Textboxes from './ui-kit/textboxes.vue';
import Tooltip from './ui-kit/tooltip.vue';
import Typography from './ui-kit/typography.vue';
import Glyphs from './ui-kit/glyphs.vue';
import SocialIcons from './ui-kit/social-icons.vue';
import Icons from './ui-kit/icons.vue';
import Labels from './ui-kit/labels.vue';

// PHD UI Kit
import PhdTypography from './ui-kit/phd/phd-typography.vue';
import PhdColorPalette from './ui-kit/phd/phd-color-palette.vue';
import PhdColorPaletteMembership from './ui-kit/phd/phd-color-palette-membership.vue';
import PhdButtons from './ui-kit/phd/phd-buttons.vue';
import PhdLinks from './ui-kit/phd/phd-links.vue';
import PhdDropdowns from './ui-kit/phd/phd-dropdowns.vue';
import PhdInputs from './ui-kit/phd/phd-inputs.vue';
import PhdInputsFeedback from './ui-kit/phd/phd-inputs-feedback.vue';
import PhdRadios from './ui-kit/phd/phd-radios.vue';
import PhdIcons from './ui-kit/phd/phd-icons.vue';
import PhdSkeletonComponent from './ui-kit/phd/phd-skeleton-component.vue';
import PhdDefaultTables from './ui-kit/phd/phd-default-tables.vue';

// Demo components
import Breadcrumb from './components/breadcrumb.vue';
import BreadcrumbWithLink from './components/breadcrumb-with-link.vue';
import ListingHeader from './components/listing-header/listing-header.vue';
import ListingHeaderMedium from './components/listing-header/listing-header-medium.vue';
import ListingHeaderSmall from './components/listing-header/listing-header-small.vue';
import Alert from './components/alert.vue';
import TopNav from './components/nav/top-nav.vue';
import LoginSignup from './components/nav/login-signup.vue';
import MainNav from './components/nav/main-nav.vue';
import MainNav2023 from './components/nav/main-nav-2023.vue';
import UtilityBar from './components/nav/utility-bar.vue';
import LargeArticle from './components/article/article-large.vue';
import MediumArticle from './components/article/article-medium.vue';
import SmallArticle from './components/article/article-small.vue';
import XSmallArticle from './components/article/article-x-small.vue';
import ListingArticle from './components/article/article-listing.vue';
import ListingWithIcons from './components/article/article-list-with-icons.vue';
import ArticleToc from './components/article/article-toc.vue';
import AroundAhaNews from './components/article/around-aha-news.vue';
import InquiriesSupport from './components/inquiries-support.vue';
import Testimonial from './components/full-width-testimonial.vue';
import FullWidthHighlightCopy from './components/full-width-highlight-copy.vue';
import VideoGallery from './components/video-gallery.vue';
import AffiliateNav from './components/nav/affiliate-nav.vue';
import SitecoreForms from './components/sitecore-forms.vue';
import InlineSearch from './components/search/inline-search.vue';
import CeSearch from './components/ce-search.vue';
import CourseSearch from './components/course-search.vue';
import CPRTopicSearch from './components/cpr-course-search.vue';
import QualityResearchPublications from './components/quality-research-publications.vue';
import MapSearch from './components/map-search.vue';
import PrintButton from './components/print-button.vue';
import RatingWidget from './components/rating-widget.vue';
import InlineSearchDropdown from './components/search/inline-search-dropdown.vue';
import InlineSearchIcon from './components/search/inline-search-icon.vue';
import InlineSearchRedirect from './components/search/inline-search-redirect.vue';
import InlineSearchSimple from './components/search/inline-search-simple.vue';
import TwoColumnContentWidthPromo from './components/promo/two-column-content-width-promo.vue';
import TwoColumnFullWidthPromo from './components/promo/two-column-full-width-promo.vue';
import TwoColumnFullBleedPromo from './components/promo/two-column-full-bleed-promo.vue';
import ThreeColumnContentWidthPromo from './components/promo/three-column-content-width-promo.vue';
import FourColumnContentWidthIconPromo from './components/promo/four-column-content-width-icon-promo.vue';
import FourColumnContentWidthImagePromo from './components/promo/four-column-content-width-image-promo.vue';
import FourColumnFullWidthImagePromo from './components/promo/four-column-full-width-image-promo.vue';
import ThreeColumnFullWidthPromo from './components/promo/three-column-full-width-promo.vue';
import FullWidthEmailPromo from './components/promo/full-width-email-promo.vue';
import HalfImageHalfCopyPromo from './components/promo/half-image-half-copy-promo.vue';
import OneColumnContentWidthPromo from './components/promo/one-column-content-width-promo.vue';
import EventPromo from './components/promo/event-promo.vue';
import TwoThirdLinkComponent from './components/two-third-link-component.vue';
import HeroCard from './components/hero-card.vue';
import EventList from './components/event-list.vue';
import HeroFullWidth from './components/hero-full-width.vue';
import FullWidthVideoImage from './components/hero-full-width-video-image.vue';
import FullWidthEvent from './components/promo/full-width-event-promo.vue';
import TvPages from './components/tv-pages.vue';
import NutritionalFacts from './components/recipe/nutritional-facts.vue';
import Instructions from './components/recipe/instructions.vue';
import QuickTips from './components/recipe/quick-tips.vue';
import RecipeGigyaAddThis from './components/recipe/social.vue';
import SpeedBump from './components/speed-bump';
import SsoInterceptor from './components/sso-interceptor';

// Student Code
import StudentCode from './components/student-code/student-code.vue';
import StudentCodeInvalid from './components/student-code/student-code-invalid.vue';

// Snackable
import DailyJourneyComponent from './components/snackable/daily-journey.vue';
import YesNoQuestionComponent from './components/snackable/yes-no-question.vue';
import SingleFieldPromptComponent from './components/snackable/single-field-prompt.vue';
import MakeCommitment from './components/snackable/make-commitment.vue';
import QuizComponent from './components/snackable/quiz.vue';
import QuizScoringComponent from './components/snackable/quiz-scoring.vue';
import PollComponent from './components/snackable/poll.vue';
import QuizPersonalisedComponent from './components/snackable/quiz-personalised.vue';
import ListicleComponent from './components/snackable/listicle.vue';

// LIW
import LiwIntroBanner from './components/liw/intro-banner.vue';
import LiwCounterComponent from './components/liw/counter-component.vue';
import LiwMultiLogoComponent from './components/liw/multi-logo-component.vue';
import LiwFlipCardComponent from './components/liw/flip-card-component.vue';

// ECC
import ColorCodedTable from './components/ecc/color-coded-table.vue';
import ECCSearch from './components/ecc/ecc-search.vue';
import NestedAccordion from './components/ecc/nested-accordion.vue';

// Stroke
import StrokeSymptoms from './components/promo/stroke-symptoms.vue';

// PHD Components
import articleListbox from './components/phd/article-listbox.vue';
import articleListComponent from './components/phd/article-list-component.vue';
import adHorizontal from './components/phd/ad-horizontal.vue';
import CommunityScienceNews from './components/phd/community-science-news.vue';
import CtaBar from './components/phd/cta-bar.vue';
import CtaBarFlexible from './components/phd/cta-bar-flexible.vue';
import Council from './components/phd/council.vue';
import ImagePDFAccessibleLinks from './components/phd/image-pdf-accessible-links.vue';
import InstitutionalTier from './components/phd/institutional-tier.vue';
import linkBox from './components/phd/linkbox.vue';
import linkBox5050 from './components/phd/linkbox-50-50.vue';
import PhdMainNav from './components/nav/phd-main-nav.vue';
import LinksToDetails from './components/phd/links-to-details.vue';
import NeedToKnow from './components/phd/need-to-know.vue';
import NewsLink from './components/phd/news-link.vue';
import NewWindowHyperlink from './components/phd/new-window-hyperlink.vue';
import NonPartnerConnections from './components/phd/non-partner-connections.vue';
import PartnerBenefits from './components/phd/partner-benefits.vue';
import PhdArticleLink from './components/phd/phd-article-link.vue';
import PhdCard from './components/phd/phd-card.vue';
import PhdCitations from './components/phd/phd-citations.vue';
import PhdMediaBlock from './components/phd/phd-media-block.vue';
import PhdMeeting from './components/phd/phd-meeting.vue';
import PhdReferences from './components/phd/phd-references.vue';
import PhdVideo from './components/phd/phd-video.vue';
import PhdVolunteerSearch from './components/phd/volunteer-search.vue';
import Profile from './components/phd/profile.vue';
import RichText from './components/phd/rich-text.vue';
import SecondaryTertiaryNav from './components/nav/phd-secondary-tertiary-nav.vue';
import SectionHeading from './components/phd/section-heading.vue';
import ScienceNewsRecentList from './components/phd/science-news/science-news-recent-list.vue';
import ScienceNewsHeading from './components/phd/science-news/science-news-heading.vue';
import ScienceNewsPromo from './components/phd/science-news/science-news-promo.vue';
import SignUpPromo from './components/phd/sign-up-promo.vue';
import TwitterFeed from './components/phd/twitter-feed.vue';
import VideoPromo from './components/phd/video-promo.vue';
import PhdTopNav from './components/nav/phd-top-nav.vue';
import PhdTopUtilityNav from './components/nav/phd-top-utility-nav.vue';
import PhdUpcomingMeetings from './components/phd/upcoming-meetings.vue';
import PhdSessionsMeetings from './components/phd/sessions/sessions-meetings.vue';
import PhdTwoCtaComponent from './components/phd/two-cta-component.vue';
import LinkedList from './components/phd/linked-list.vue';
import PhdHero from './components/phd/phd-hero.vue';

// PHD Pages
import ThingsToKnow from './components/things-to-know.vue';
import PhdMemberDashboardAccountSummary from './pages/layouts/phd-member-dashboard-account-summary.vue';
import PhdLinkedListDemo from './pages/components/phd-linked-list-demo.vue';
import PhdLinkedListViewAllPage from './components/phd/linked-list-view-all-page.vue';

import routes from './routes';

// Plugins
import VJSDropdown from '@/plugins/vjs-dropdown/authoring';

// Expose VanillaJS Dropdown plugin to Global scope
window.VJSDropdown = new VJSDropdown();

Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(VeeValidate);
Vue.use(VueScrollTo);

// UI Kit
Vue.component('aha-ui-buttons', Buttons);
Vue.component('aha-ui-color-palette', ColorPalette);
Vue.component('aha-ui-dropdown', Dropdown);
Vue.component('aha-ui-facets', Facets);
Vue.component('aha-ui-inputs-feedback', InputsFeedback);
Vue.component('aha-ui-inputs', Inputs);
Vue.component('aha-ui-large-inputs-feedback', LargeInputsFeedback);
Vue.component('aha-ui-large-inputs', LargeInputs);
Vue.component('aha-ui-pagination', Pagination);
Vue.component('aha-ui-radio-buttons', RadioButtons);
Vue.component('aha-ui-tabs', Tabs);
Vue.component('aha-ui-tags', Tags);
Vue.component('aha-ui-textboxes', Textboxes);
Vue.component('aha-ui-tooltip', Tooltip);
Vue.component('aha-ui-typography', Typography);
Vue.component('aha-ui-glyphs', Glyphs);
Vue.component('aha-ui-social-icons', SocialIcons);
Vue.component('aha-ui-icons', Icons);
Vue.component('aha-ui-labels', Labels);

// PHD UI Kit
Vue.component('phd-typography', PhdTypography);
Vue.component('phd-ui-color-palette', PhdColorPalette);
Vue.component('phd-ui-color-palette-membership', PhdColorPaletteMembership);
Vue.component('phd-buttons', PhdButtons);
Vue.component('phd-links', PhdLinks);
Vue.component('phd-dropdowns', PhdDropdowns);
Vue.component('phd-inputs', PhdInputs);
Vue.component('phd-inputs-feedback', PhdInputsFeedback);
Vue.component('phd-radios', PhdRadios);
Vue.component('phd-icons', PhdIcons);
Vue.component('phd-skeleton-component', PhdSkeletonComponent);
Vue.component('phd-default-tables', PhdDefaultTables);

// Demo components
Vue.component('aha-component', Component);
Vue.component('aha-breadcrumb', Breadcrumb);
Vue.component('aha-breadcrumb-with-link', BreadcrumbWithLink);
Vue.component('aha-listing-header', ListingHeader);
Vue.component('aha-listing-header-medium', ListingHeaderMedium);
Vue.component('aha-listing-header-small', ListingHeaderSmall);
Vue.component('aha-alert', Alert);
Vue.component('aha-top-nav', TopNav);
Vue.component('aha-login-signup', LoginSignup);
Vue.component('aha-main-nav', MainNav);
Vue.component('aha-main-nav-2023', MainNav2023);
Vue.component('aha-utility-bar', UtilityBar);
Vue.component('aha-article-large', LargeArticle);
Vue.component('aha-article-medium', MediumArticle);
Vue.component('aha-article-small', SmallArticle);
Vue.component('aha-article-xsmall', XSmallArticle);
Vue.component('aha-article-listing', ListingArticle);
Vue.component('aha-article-list-with-icons', ListingWithIcons);
Vue.component('aha-article-toc', ArticleToc);
Vue.component('around-aha-news', AroundAhaNews);
Vue.component('aha-inquiries-support', InquiriesSupport);
Vue.component('aha-testimonial', Testimonial);
Vue.component('aha-full-width-highlight-copy', FullWidthHighlightCopy);
Vue.component('aha-video-gallery', VideoGallery);
Vue.component('aha-affiliate-nav', AffiliateNav);
Vue.component('aha-sitecore-forms', SitecoreForms);

Vue.component('aha-inline-search', InlineSearch);
Vue.component('aha-ce-search', CeSearch);
Vue.component('aha-course-search', CourseSearch);
Vue.component('aha-cpr-course-search', CPRTopicSearch);
Vue.component('aha-quality-research-publications', QualityResearchPublications);
Vue.component('aha-map-search', MapSearch);
Vue.component('aha-print-button', PrintButton);
Vue.component('aha-rating-widget', RatingWidget);
Vue.component('aha-inline-search-dropdown', InlineSearchDropdown);
Vue.component('aha-inline-search-icon', InlineSearchIcon);
Vue.component('aha-inline-search-redirect', InlineSearchRedirect);
Vue.component('aha-inline-search-simple', InlineSearchSimple);

Vue.component('aha-two-column-content-width-promo', TwoColumnContentWidthPromo);
Vue.component('aha-two-column-full-width-promo', TwoColumnFullWidthPromo);
Vue.component('aha-two-column-full-bleed-promo', TwoColumnFullBleedPromo);
Vue.component('aha-three-column-content-width-promo', ThreeColumnContentWidthPromo);
Vue.component('aha-four-column-content-width-icon-promo', FourColumnContentWidthIconPromo);
Vue.component('aha-four-column-content-width-image-promo', FourColumnContentWidthImagePromo);
Vue.component('aha-four-column-full-width-image-promo', FourColumnFullWidthImagePromo);
Vue.component('aha-three-column-full-width-promo', ThreeColumnFullWidthPromo);
Vue.component('aha-two-third-link-component', TwoThirdLinkComponent);
Vue.component('aha-full-width-email-promo', FullWidthEmailPromo);
Vue.component('aha-half-image-half-copy-promo', HalfImageHalfCopyPromo);
Vue.component('aha-one-column-content-width-promo', OneColumnContentWidthPromo);
Vue.component('aha-event-promo', EventPromo);

Vue.component('aha-hero-card', HeroCard);
Vue.component('aha-hero-full-width', HeroFullWidth);
Vue.component('aha-event-list', EventList);
Vue.component('aha-full-width-video-image', FullWidthVideoImage);
Vue.component('aha-full-width-event', FullWidthEvent);
Vue.component('aha-rating-widget', RatingWidget);

Vue.component('aha-tv-pages', TvPages);

// LIW Components
Vue.component('liw-intro-banner', LiwIntroBanner);
Vue.component('liw-counter-component', LiwCounterComponent);
Vue.component('liw-multi-logo-component', LiwMultiLogoComponent);
Vue.component('liw-flip-card-component', LiwFlipCardComponent);

// ECC components
Vue.component('color-coded-table', ColorCodedTable);
Vue.component('ecc-search', ECCSearch);
Vue.component('nested-accordion', NestedAccordion);

// PHD components
Vue.component('article-listbox', articleListbox);
Vue.component('article-list-component', articleListComponent);
Vue.component('ad-horizontal', adHorizontal);
Vue.component('community-science-news', CommunityScienceNews);
Vue.component('cta-bar', CtaBar);
Vue.component('cta-bar-flexible', CtaBarFlexible);
Vue.component('phd-council', Council);
Vue.component('image-pdf-accessible-links', ImagePDFAccessibleLinks);
Vue.component('institutional-tier', InstitutionalTier);
Vue.component('link-box', linkBox);
Vue.component('link-box-50-50', linkBox5050);
Vue.component('phd-main-nav', PhdMainNav);
Vue.component('links-to-details', LinksToDetails);
Vue.component('need-to-know', NeedToKnow);
Vue.component('news-link', NewsLink);
Vue.component('new-window-hyperlink', NewWindowHyperlink);
Vue.component('non-partner-connections', NonPartnerConnections);
Vue.component('partner-benefits', PartnerBenefits);
Vue.component('phd-card', PhdCard);
Vue.component('phd-article-link', PhdArticleLink);
Vue.component('phd-citations', PhdCitations);

Vue.component('phd-media-block', PhdMediaBlock);
Vue.component('phd-meeting', PhdMeeting);
Vue.component('phd-references', PhdReferences);
Vue.component('phd-video', PhdVideo);
Vue.component('rich-text', RichText);
Vue.component('science-news-heading', ScienceNewsHeading);
Vue.component('science-news-promo', ScienceNewsPromo);
Vue.component('secondary-tertiary-nav', SecondaryTertiaryNav);
Vue.component('section-heading', SectionHeading);
Vue.component('sign-up-promo', SignUpPromo);
Vue.component('video-promo', VideoPromo);
Vue.component('phd-volunteer-search', PhdVolunteerSearch);
Vue.component('phd-profile', Profile);
Vue.component('science-news-recent-list', ScienceNewsRecentList);
Vue.component('phd-top-nav', PhdTopNav);
Vue.component('phd-top-utility-nav', PhdTopUtilityNav);
Vue.component('phd-upcoming-meetings', PhdUpcomingMeetings);
Vue.component('sessions-meetings', PhdSessionsMeetings);
Vue.component('twitter-feed', TwitterFeed);
Vue.component('two-cta-component', PhdTwoCtaComponent);
Vue.component('linked-list', LinkedList);
Vue.component('phd-hero', PhdHero);

// PHD Pages
Vue.component('aha-things-to-know', ThingsToKnow);
Vue.component('phd-member-dashboard-account-summary', PhdMemberDashboardAccountSummary);
Vue.component('aha-nutritional-facts', NutritionalFacts);
Vue.component('aha-recipe-instructions', Instructions);
Vue.component('aha-quick-tips', QuickTips);
Vue.component('aha-recipe-gigya-addthis', RecipeGigyaAddThis);
Vue.component('aha-listicle-component', ListicleComponent);
Vue.component('aha-quiz-scoring-component', QuizScoringComponent);
Vue.component('aha-quiz-personalised-component', QuizPersonalisedComponent);
Vue.component('aha-quiz-component', QuizComponent);
Vue.component('aha-poll-component', PollComponent);
Vue.component('aha-daily-journey-component', DailyJourneyComponent);
Vue.component('aha-yes-no-question-component', YesNoQuestionComponent);
Vue.component('aha-single-field-prompt-component', SingleFieldPromptComponent);
Vue.component('aha-make-commitment-component', MakeCommitment);
Vue.component('aha-student-code', StudentCode);
Vue.component('aha-student-code-invalid', StudentCodeInvalid);
Vue.component('aha-speed-bump', SpeedBump);
Vue.component('aha-sso-interceptor', SsoInterceptor);
Vue.component('asa-stroke-symptoms', StrokeSymptoms);
Vue.component('phd-linked-list-demo', PhdLinkedListDemo);
Vue.component('phd-linked-list-view-all-page', PhdLinkedListViewAllPage);

const router = new VueRouter({
    routes
});

new Vue({
    el: '#app',
    render: h => h(App),
    router: router
});

/* eslint-disable */
router.afterEach((to, from) => {
    setTimeout(() => {
        setSpeedBumpClassLinks('.twoClick, .twoclick', '#speed-bump-link');
        // setSsoInterceptLinks('#sso-intercept-link'); // removed by C.Castle
        selectAll();

        // Globally exposed plugins
        window.VJSDropdown.destroy();
        window.VJSDropdown.init();

        customEventPolyfill();
        objectFitPolyfill();
    }, 150);
});

setSpeedBumpClassLinks('.twoClick, .twoclick', '#speed-bump-link');
// setSsoInterceptLinks('#sso-intercept-link'); // removed by C.Castle
selectAll();

// Globally exposed plugins
window.VJSDropdown.init();

// Polyfills
customEventPolyfill();
objectFitPolyfill();
focusWithinPolyfill();



// WEBPACK FOOTER //
// ./demo/index.js